<template>
  <div class="layout">
    <Header />
    <Content />
    <Footer />
    <!-- <Cookies /> -->
    <GoTop />
  </div>
</template>

<script>
import Header from '@/components/layouts/Header.vue';
import Content from '@/components/layouts/Content.vue';
import Footer from '@/components/layouts/Footer.vue';
// import Cookies from '@/components/layouts/Cookies.vue';
import GoTop from '@/components/layouts/GoTop.vue';

export default {
  components: {
    Header,
    Content,
    Footer,
    // Cookies,
    GoTop,
  },
};
</script>

<style lang="scss" scoped>
</style>
